<template v-if="reviewLists.length>0">
    <b-dropdown
          id="ddown1"
          :text="title"
          class="m-md-2 btn-sm-drop statusbtn"
          ref="ddown1"
          @hidden="$emit('hidden')"
          @shown="overflow"
        >
        <template v-slot:button-content>
          <span class="dropdown-text">{{ title }}</span>
          <span class="dropdown-caret">▼</span>
        </template>
        <div class="form-group-row" style="position: relative; max-height: 200px;overflow-y:scroll">
          <div class="form-check ml-2 p-1"
            v-for="(list) in reviewLists"
            :key="list._id"
          >
            <input
              class="form-check-input"
              type="radio"
              :id="list._id"
              name="reviewList"
              :value="list._id"
              :checked="reviewListModel === list._id"
              @click="reviewListModel = (reviewListModel === list._id) ? null : list._id"
            >
            <label class="form-check-label" :for="list._id">
              {{ truncateTitle(list.title) }}
            </label>
          </div>
        </div>
          <div class="dropdown-footer p-2" style="display: flex; flex-direction: row;">
            <button @click="()=>this.$refs.ddown1.hide()" class="btn btn-outline-danger mr-1" style="min-width:100px!important;">キャンセル</button>
            <button @click.prevent="assignToReviewList()" class="btn btn-primary" style="min-width:80px!important">保存</button>
          </div>
        </b-dropdown>
</template>
<script>
import Api from '@/config/api';
import ApiService from '@/service/apiService';
import { mapGetters, mapMutations, mapActions } from 'vuex';

export default {
  name: 'ReviewListDropdown',
  props: ['applicant', 'toggledisabledstatus','isReviewer'],
  data() {
    return {
      overflowState: 0,
      current_status: this.applicant.status,
    };
  },
  computed:{
    ...mapGetters({
        reviewLists:"getReviewLists",
        getReviewListModel: "getReviewListModel"
    }),
    title() {
      return this.applicant.review_lists ? this.applicant.review_lists.title : 'リストに振分け';
    },
    isListSelected() {
        return (list) => {
            return this.selectedReviewListId == list._id;
        };  
    },
    reviewListModel: {
        get() {
            return this.getReviewListModel;
        },
        set(value) {
            this.setReviewListModel(value);
        },
    },
    checkReviewListIfAssigned(){
        if(this.applicant.review_list ){
          return this.applicant.review_list.title;
        }
        // let reviewList = this.reviewLists.find((list)=>{
        //     return list._id == this.applicant.review_list.id
        // })
        // if(reviewList) return reviewList.title;
        return '社内確認待ち一覧一括追加';
    },
  },
  methods: {
    ...mapMutations({
      mutateApplicantsAfterStatus: 'mutateApplicantsAfterStatus',
      setReviewListModel: 'setReviewListModel',
      mutateApplicantsAfterReviewList: 'mutateApplicantsAfterReviewList',
      setApplicantReviewList: 'setApplicantReviewList'
    }),
    ...mapActions({
      loadReviewLists: 'loadReviewLists'
    }),
    overflow() {
      this.overflowState = 1;
    },
    isReviewListSelected(list) {
        return this.selectedReviewListId === list._id;
    },
    selectReviewList(id) {
         if (this.selectedReviewListId === id) {
            // If the same radio button is clicked again, unselect it
            this.selectedReviewListId = null;
        } else {
            // Otherwise, select the clicked radio button
            this.selectedReviewListId = id;
        }
    },
    assignToReviewList(){
         ApiService.put(Api.endpoints.ASSIGN_TO_REVIEW_LIST(this.applicant.id), {
          list: this.getReviewListModel
        })
          .then(({ data }) => {
            this.mutateApplicantsAfterReviewList({ applicant: data.data, fromPopup: true });
            this.setApplicantReviewList(data.data.review_lists);
            this.$emit('statusChanged', data.data);
            this.mutateApplicantsAfterStatus(data.data)
          })
          .catch((error) => console.log(error.response))
          .then(() => {
            this.loading = false;
            this.$refs.ddown1.hide()
        });
    },
    truncateTitle(title) {
      if (!title) return '';
      if (title.length <= 12) return title;
      return title.substring(0, 12) + '…';
    },
    changeStatus(status) {
      this.current_status = 'loading... ';
      ApiService.put(Api.endpoints.CLIENT_STATUS_CHANGE(this.applicant.id), {
        status,
      })// eslint-disable-next-line
        .then(({ data }) => {
          this.current_status = status;
          this.$emit('statusChanged', status);
          this.mutateApplicantsAfterStatus(data.data);
        })
        .catch(({ response }) => this.parseErrorResponse(response));
    },
  },
  mounted(){
    this.loadReviewLists();
    if(this.applicant.review_lists){
        this.setReviewListModel(this.applicant.review_lists.id);
    }else{
        this.setReviewListModel([]);
    }
  }
};
</script>
<style scoped>
>>> .dropdown-toggle {
  display: flex;
  align-items: center;
  justify-content: center;
  max-width: 120px;
}

.dropdown-text {
  /* display: inline-block;
  white-space: nowrap; */
  overflow: hidden;
  margin-right: 5px; /* Space between text and caret */
}
>>> .dropdown-toggle::after {
  display: none !important
}

.form-check-label {
  white-space: inherit;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 100%;
}
</style>


